/* eslint-disable */

import Vue from 'vue'

const shareData = {
  roles: []
  //....
}
const bus = new Vue({
  data: {
    // privateState: {},
    // sharedState: store.state
    shareData: shareData
  },
  methods: {
    emit(event, ...args) {
      this.$emit(event, ...args)
    },
    on(event, callback) {
      this.$on(event, callback)
    },
    off(event, callback) {
      this.$off(event, callback)
    },
    once(event, callback) {
      this.$once(event, callback)
    }
  }
})

export default { bus }

/**
 *
 * triggler this.$bus.emit('eventName', arg1, arg2.....)
 * accept   this.$bus.on('eventName', (arg1, arg2.....) => {
 *    XXXX
 * })
 *
 */

/* eslint-enable */
